import { buildReport } from '@muzly/voice-engine';
import type { ClipSet } from '@muzly/voice-engine';

import { storedScores } from './record';
import { toSurveyAnswers } from './survey';

import type { OnboardingAnswer } from './flow';
import type { SongScore } from './songScoring';

/**
 * segmentScore — 테이크(세그먼트) 하나의 점수. `record/toDiagnosisRecord.ts`의
 * `overallScore()`와 **같은 산식**(저장 축 균등 평균, 정수 반올림)을 쓴다 — 결과 화면과
 * 서버 메인 `score`가 갈리면 안 되기 때문(plan Review Focus 03).
 *
 * 훅 밖의 순수 함수로 둔다 — 훅 안에 두면 테스트가 렌더 사이클에 묶인다(plan Seams).
 */

/**
 * 지속음 테이크 경계에서의 점수. 그 시점 클립으로 `buildReport`를 다시 불러 낸 저장 축
 * (`storedScores` — 잰 것만)의 평균이다. 무효 지속음(`isValidVoice` 실패로 `buildReport`가
 * null)이면 `undefined`다 — 0점이 아니라 "못 잼"이다(plan RISK).
 */
export const sustainSegmentScore = (
  clips: ClipSet,
  answers: Record<string, OnboardingAnswer>,
): number | undefined => {
  const report = buildReport(clips, toSurveyAnswers(answers));
  if (!report) {
    return undefined;
  }
  const scores = storedScores(report.metrics);
  if (scores.length === 0) {
    return undefined;
  }
  const sum = scores.reduce((total, s) => total + s.val, 0);
  return Math.round(sum / scores.length);
};

/**
 * 노래 테이크 점수 — 결과 화면 "진단 3"과 같은 수(`accuracy` 반올림, plan Decisions Q2).
 * 안 불렀거나 측정 불가면 `undefined`다.
 */
export const songSegmentScore = (
  songScore: SongScore | undefined,
): number | undefined =>
  songScore === undefined ? undefined : Math.round(songScore.accuracy);
